import { styled } from "styled-components";

export const IntlCostCardContainer = styled.div<{ $showLabels?: boolean }>`
  display: flex;
  padding: 24px;
  width: 100%;
  gap: 24px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: ${({ $showLabels }) =>
    $showLabels ? "12px 12px 0px 0px" : "0"};
  background: ${({ theme }) => theme.colors.base};
`;

export const CountryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%%;
`;

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const PriceLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

export const Labels = styled.div<{ $showLabels?: boolean }>`
  display: ${({ $showLabels }) => ($showLabels ? "flex" : "none")};
  align-items: center;
  justify-content: space-between;
  width: 100%;
  nth-of-type(1) {
    display: none;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Price = styled.div`
  color: ${({ theme }) => theme.colors.default[400]};
`;

export const Destination = styled.div`
  display: flex;
  width: 204px;
  align-items: center;
  gap: 12px;
`;

export const Flag = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;
